import { useContext } from "react";
import { InputCostEstimationDialogContext, PageNewState } from ".";

export const useInputCostEstimationDialogState = () => {
  const { pageState, setPageState } = useContext(
    InputCostEstimationDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
